/* ============================================================
   Comfort Co — Shopify Theme JS
   Vanilla JS: cart drawer, search modal, mobile nav,
   gallery, accordions, sticky ATC, scroll animations
   ============================================================ */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }

  /* ── Mobile Nav ──────────────────────────────────────────── */
  function initMobileNav() {
    const btn = $('#mobile-menu-open');
    const closeBtn = $('#mobile-menu-close');
    const nav = $('#mobile-nav');
    if (!btn || !nav) return;
    on(btn, 'click', () => { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    on(closeBtn, 'click', close);
    function close() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
  }

  /* ── Search Modal ────────────────────────────────────────── */
  function initSearchModal() {
    const openBtns = $$('[data-search-open]');
    const overlay = $('#search-modal-overlay');
    const closeBtn = $('#search-modal-close');
    const input = $('#search-modal-input');
    const results = $('#search-results');
    if (!overlay) return;

    openBtns.forEach(btn => on(btn, 'click', open));
    on(closeBtn, 'click', close);
    on(overlay, 'click', e => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    let debounceTimer;
    on(input, 'input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => search(input.value.trim()), 300);
    });

    function open() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input && input.focus(), 50);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    async function search(query) {
      if (!query || query.length < 2) { results.innerHTML = ''; return; }
      results.innerHTML = '<p style="padding:1rem;color:var(--color-muted-fg);font-size:.875rem">Searching...</p>';
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
        const data = await res.json();
        const products = data.resources?.results?.products || [];
        if (!products.length) {
          results.innerHTML = '<p style="padding:1rem;color:var(--color-muted-fg);font-size:.875rem">No results found.</p>';
          return;
        }
        results.innerHTML = products.map(p => `
          <a href="${p.url}" class="search-result-item">
            <div class="search-result-image">
              <img src="${p.image}" alt="${p.title}" loading="lazy">
            </div>
            <div>
              <div class="search-result-title">${p.title}</div>
              <div class="search-result-price">${p.price}</div>
            </div>
          </a>`).join('');
      } catch (e) {
        results.innerHTML = '<p style="padding:1rem;color:var(--color-muted-fg);font-size:.875rem">Something went wrong.</p>';
      }
    }
  }

  /* ── Cart Drawer ─────────────────────────────────────────── */
  function initCartDrawer() {
    const overlay = $('#cart-drawer-overlay');
    const drawer = $('#cart-drawer');
    const openBtns = $$('[data-cart-open]');
    const closeBtn = $('#cart-drawer-close');
    if (!overlay) return;

    openBtns.forEach(btn => on(btn, 'click', open));
    on(closeBtn, 'click', close);
    on(overlay, 'click', e => { if (e.target === overlay) close(); });

    function open() {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      refreshDrawer();
    }
    function close() {
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    async function refreshDrawer() {
      const body = $('#cart-drawer-body');
      const subtotalEl = $('#cart-drawer-subtotal-price');
      const countEl = $('#cart-drawer-count');
      if (!body) return;
      body.innerHTML = '<p style="text-align:center;padding:2rem;color:var(--color-muted-fg)">Loading...</p>';
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        updateCartCount(cart.item_count);
        if (countEl) countEl.textContent = cart.item_count;
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (!cart.item_count) {
          body.innerHTML = '<div style="text-align:center;padding:2rem"><p style="color:var(--color-muted-fg);margin-bottom:1rem">Your cart is empty.</p><a href="/collections/all" class="btn btn-primary btn-sm">Shop Now</a></div>';
          return;
        }
        body.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-line-key="${item.key}">
            <div class="cart-item-image">
              <a href="${item.url}"><img src="${item.image}" alt="${item.product_title}" loading="lazy"></a>
            </div>
            <div class="cart-item-details">
              <div class="cart-item-title">${item.product_title}</div>
              ${item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
              <div style="display:flex;align-items:center;justify-content:space-between;margin-top:.5rem">
                <div class="quantity-selector" style="transform:scale(0.85);transform-origin:left">
                  <button data-change="-1" data-key="${item.key}">−</button>
                  <input type="number" value="${item.quantity}" min="0" data-key="${item.key}" style="width:36px">
                  <button data-change="1" data-key="${item.key}">+</button>
                </div>
                <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
              </div>
            </div>
            <button class="header-icon-btn" style="flex-shrink:0" data-remove-key="${item.key}" title="Remove">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
          </div>`).join('');

        // Quantity change handlers
        $$('[data-change]', body).forEach(btn => {
          on(btn, 'click', async () => {
            const key = btn.dataset.key;
            const input = body.querySelector(`input[data-key="${key}"]`);
            const newQty = Math.max(0, parseInt(input.value) + parseInt(btn.dataset.change));
            await updateItem(key, newQty);
            refreshDrawer();
          });
        });
        $$('[data-remove-key]', body).forEach(btn => {
          on(btn, 'click', async () => { await updateItem(btn.dataset.removeKey, 0); refreshDrawer(); });
        });
        $$('input[data-key]', body).forEach(input => {
          on(input, 'change', async () => { await updateItem(input.dataset.key, parseInt(input.value)); refreshDrawer(); });
        });
      } catch (e) { console.error('Cart drawer error:', e); }
    }
    window.refreshCartDrawer = refreshDrawer;
  }

  async function updateItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateCartCount(cart.item_count);
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ── Add to Cart ─────────────────────────────────────────── */
  function initAddToCart() {
    const form = $('#product-form');
    if (!form) return;
    on(form, 'submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[data-atc-btn]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
      if (!variantId) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        if (!res.ok) throw new Error('Failed');
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        showToast('Added to cart!', 'success');
        const drawerOverlay = $('#cart-drawer-overlay');
        if (drawerOverlay) {
          drawerOverlay.classList.add('is-open');
          $('#cart-drawer')?.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          window.refreshCartDrawer?.();
        }
      } catch (err) {
        showToast('Could not add to cart. Please try again.', 'error');
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      }
    });
  }

  /* ── Variant Selection ───────────────────────────────────── */
  function initVariantSelector() {
    const form = $('#product-form');
    if (!form) return;
    const optionBtns = $$('.option-btn', form);
    const variantInput = form.querySelector('[name="id"]');

    optionBtns.forEach(btn => {
      on(btn, 'click', () => {
        const name = btn.dataset.optionName;
        $$(`[data-option-name="${name}"]`, form).forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateSelectedVariant();
      });
    });

    function updateSelectedVariant() {
      const selectedOptions = {};
      $$('[data-option-name]', form).forEach(btn => {
        if (btn.classList.contains('is-selected')) selectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
      });
      const variants = JSON.parse(form.dataset.variants || '[]');
      const match = variants.find(v =>
        v.options.every((opt, i) => opt === Object.values(selectedOptions)[i])
      );
      if (match && variantInput) variantInput.value = match.id;
      const atcBtn = form.querySelector('[data-atc-btn]');
      if (atcBtn) {
        atcBtn.disabled = match ? !match.available : true;
        atcBtn.textContent = match ? (match.available ? 'Add to Cart' : 'Sold Out') : 'Unavailable';
      }
      if (match) {
        const priceEl = $('.product-price .price');
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        const compareEl = $('.product-price .compare');
        if (compareEl) {
          if (match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = 'inline';
          } else { compareEl.style.display = 'none'; }
        }
      }
    }
  }

  /* ── Quantity Selector ───────────────────────────────────── */
  function initQuantity() {
    $$('.quantity-selector').forEach(sel => {
      const input = sel.querySelector('input');
      sel.querySelectorAll('button').forEach(btn => {
        on(btn, 'click', () => {
          const delta = btn.textContent.trim() === '−' ? -1 : 1;
          const newVal = Math.max(1, parseInt(input.value || 1) + delta);
          input.value = newVal;
        });
      });
    });
  }

  /* ── Product Gallery ─────────────────────────────────────── */
  function initGallery() {
    const mainImg = $('#gallery-main-img');
    const thumbs = $$('.gallery-thumb');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(thumb => {
      on(thumb, 'click', () => {
        const src = thumb.dataset.src;
        const alt = thumb.querySelector('img')?.alt;
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── Accordions ──────────────────────────────────────────── */
  function initAccordions() {
    $$('.accordion-trigger').forEach(trigger => {
      on(trigger, 'click', () => {
        const item = trigger.closest('.accordion-item');
        const isOpen = item.classList.contains('is-open');
        $$('.accordion-item').forEach(i => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Sticky ATC ──────────────────────────────────────────── */
  function initStickyATC() {
    const atcBtn = $('[data-atc-btn]');
    const sticky = $('#sticky-atc');
    if (!atcBtn || !sticky) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(atcBtn);
    const stickyBtn = sticky.querySelector('[data-atc-btn]');
    if (stickyBtn) {
      on(stickyBtn, 'click', () => {
        const form = $('#product-form');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* ── Newsletter Form ─────────────────────────────────────── */
  function initNewsletter() {
    const form = $('#newsletter-form');
    if (!form) return;
    on(form, 'submit', async e => {
      e.preventDefault();
      const email = form.querySelector('[name="contact[email]"]')?.value;
      if (!email) return;
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Subscribing...'; }
      try {
        await fetch('/contact#newsletter-form', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        });
        const success = $('#newsletter-success');
        if (success) { success.style.display = 'block'; form.style.display = 'none'; }
        else showToast('Thanks for subscribing! Check your inbox.', 'success');
      } catch { showToast('Something went wrong. Please try again.', 'error'); }
      finally { if (btn) { btn.disabled = false; btn.textContent = 'Subscribe'; } }
    });
  }

  /* ── Contact Form ────────────────────────────────────────── */
  function initContactForm() {
    const form = $('#contact-form');
    if (!form) return;
    on(form, 'submit', e => {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    });
  }

  /* ── Scroll Animations ───────────────────────────────────── */
  function initScrollAnimations() {
    const els = $$('.animate-on-scroll');
    if (!els.length) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => observer.observe(el));
  }

  /* ── Toast ───────────────────────────────────────────────── */
  function showToast(message, type = 'info') {
    let container = $('.toast-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'toast-container';
      document.body.appendChild(container);
    }
    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="${type === 'success' ? 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' : 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'}"/>
      </svg>
      <span>${message}</span>`;
    container.appendChild(toast);
    setTimeout(() => { toast.style.opacity = '0'; toast.style.transform = 'translateX(20px)'; toast.style.transition = 'all 0.3s'; setTimeout(() => toast.remove(), 300); }, 3500);
  }
  window.showToast = showToast;

  /* ── Collection Filters ──────────────────────────────────── */
  function initCollectionFilters() {
    const form = $('#collection-filter-form');
    if (!form) return;
    form.querySelectorAll('input, select').forEach(input => {
      on(input, 'change', () => form.submit());
    });
    const clearBtn = $('#clear-filters');
    if (clearBtn) {
      on(clearBtn, 'click', () => {
        const url = new URL(window.location.href);
        url.search = '';
        window.location.href = url.toString();
      });
    }
  }

  /* ── Back to Top ─────────────────────────────────────────── */
  function initBackToTop() {
    const btn = $('#back-to-top');
    if (!btn) return;
    on(window, 'scroll', () => {
      btn.style.opacity = window.scrollY > 400 ? '1' : '0';
      btn.style.pointerEvents = window.scrollY > 400 ? 'auto' : 'none';
    });
    on(btn, 'click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ── Quick Add (from product cards) ─────────────────────── */
  function initQuickAdd() {
    document.addEventListener('click', async e => {
      const btn = e.target.closest('.product-card-atc');
      if (!btn) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      const originalHtml = btn.innerHTML;
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="animation:spin .6s linear infinite"><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" opacity=".2"/><path d="M21 12A9 9 0 0112 3"/></svg>';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });
        if (!res.ok) throw new Error('Add failed');
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/></svg> Added!`;
        btn.classList.add('is-added');
        showToast('Added to cart!', 'success');
        const drawerOverlay = $('#cart-drawer-overlay');
        if (drawerOverlay) {
          drawerOverlay.classList.add('is-open');
          $('#cart-drawer')?.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          window.refreshCartDrawer?.();
        }
        setTimeout(() => {
          btn.innerHTML = originalHtml;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2200);
      } catch {
        showToast('Could not add to cart. Please try again.', 'error');
        btn.innerHTML = originalHtml;
        btn.disabled = false;
      }
    });
  }

  /* ── Wishlist Toggle ─────────────────────────────────────── */
  function initWishlist() {
    const STORAGE_KEY = 'cc_wishlist';
    function getList() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; }
    }
    function saveList(list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    }
    function syncUI() {
      const list = getList();
      $$('[data-wishlist-toggle]').forEach(btn => {
        const handle = btn.dataset.wishlistToggle;
        const isWished = list.includes(handle);
        btn.classList.toggle('is-wished', isWished);
        btn.innerHTML = isWished
          ? '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.218l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z"/></svg>'
          : '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/></svg>';
      });
    }
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      const handle = btn.dataset.wishlistToggle;
      const list = getList();
      const idx = list.indexOf(handle);
      if (idx === -1) {
        list.push(handle);
        showToast('Added to wishlist ♥', 'success');
      } else {
        list.splice(idx, 1);
        showToast('Removed from wishlist', 'info');
      }
      saveList(list);
      syncUI();
    });
    syncUI();
  }

  /* ── Spin keyframe (inline for quick-add spinner) ──────── */
  function injectSpinKeyframe() {
    if (document.getElementById('cc-spin-kf')) return;
    const s = document.createElement('style');
    s.id = 'cc-spin-kf';
    s.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(s);
  }

  /* ── Init ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    injectSpinKeyframe();
    initMobileNav();
    initSearchModal();
    initCartDrawer();
    initAddToCart();
    initVariantSelector();
    initQuantity();
    initGallery();
    initAccordions();
    initStickyATC();
    initNewsletter();
    initContactForm();
    initScrollAnimations();
    initCollectionFilters();
    initBackToTop();
    initQuickAdd();
    initWishlist();

    // Init cart count on page load
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateCartCount(cart.item_count))
      .catch(() => {});
  });
})();
